import type { RouteRecordRaw } from 'vue-router'

const sleepMonitorRoutes: RouteRecordRaw[] = [
  {
    path: 'sleep-monitor',
    name: 'sleep-monitor',
    meta: {
      titleKey: 'routes.sleep-monitor.title',
      icon: 'Monitor',
      helpKey: 'sleep_monitor'
    },
    redirect: { name: 'sleep-monitor-devices' },
    children: [
      {
        path: 'devices',
        name: 'sleep-monitor-devices',
        component: () => import('@/views/sleep-monitor/SleepMonitorDevices.vue'),
        meta: { titleKey: 'routes.sleep-monitor.devices.title', helpKey: 'sleep_monitor_devices' }
      },
      {
        path: 'bindings',
        name: 'sleep-monitor-bindings',
        component: () => import('@/views/sleep-monitor/DeviceUserBinding.vue'),
        meta: { titleKey: 'routes.sleep-monitor.bindings.title', helpKey: 'sleep_monitor_bindings' }
      },
      {
        path: 'reports',
        name: 'sleep-monitor-reports',
        component: () => import('@/views/sleep-data/SleepReportTrends.vue'),
        meta: { titleKey: 'routes.sleep-monitor.reports.title', helpKey: 'sleep_monitor_reports' }
      }
    ]
  }
]

export default sleepMonitorRoutes
